import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ScrollToTop from "../../ScrollToTop"

function ProductList() {
  const [myData, setMyData] = useState([]);
  const [isError, setIsError] = useState("");
  const [productName, setProductName] = useState("");

  // const location = useLocation();
  // const dataId = location.state.id;

  const { id } = useParams();
  const dataId = id;

  const navigate = useNavigate();

  const productNavigate = (id) => {
    navigate("/products/"+id);
  };

  const getMyProductData = async () => {
    try {
      const response = await fetch("/db.json"); // Assuming db.json is in the public folder
      if (response.ok) {
        const data = await response.json();
        const proName = data.posts.filter(
          (item) => item.id == dataId
        );
        setProductName(proName[0]['title'])
        console.log(productName)
        const filteredData = data.comments.filter(
          (item) => item.postId == dataId
        );
        setMyData(filteredData);
      } else {
        throw new Error("Error loading JSON data");
      }
    } catch (error) {
      setIsError(error.message);
    }
  };

  useEffect(() => {
    // getMyPoductData();
    getMyProductData();
  }, []);

  return (
    <>
        <ScrollToTop />
      <div className="page-content">
        {/* Banner Area */}
        <div className="aon-page-benner-area2">
          <div className="aon-page-banner-row2">
            <div className="aon-page-benner-overlay2" />
            <div className="sf-banner-heading-wrap2">
              <div className="sf-banner-heading-area2">
                <div className="sf-banner-breadcrumbs-nav2">
                  <ul className="list-inline">
                    <li>
                      <a href="/"> Home </a>
                    </li>
                    <li>Product</li>
                  </ul>
                </div>
                <div className="sf-banner-heading-large2">
                  {productName ? productName : 'Products'}
                </div>
              </div>
              {/* <div className="sf-banner-vid-section">
                <div className="video-play-btn2">
                  <a
                    className="mfp-video"
                    href="https://www.youtube.com/watch?v=c1XNqw2gSbU"
                  >
                    <i className="fa fa-play" />
                  </a>
                  <span>
                    Watch Now <br />
                    Companey Details
                  </span>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        {/* Banner Area End */}
        {/* Product Section */}
        <div className="aon-shop-wrap">
          <div className="site-top-line" />
          <div className="container">
            <div className="product-listing-area">
              <div className="row">
    
                <div className="col-lg-9 col-md-12">
                  {/* <div className="product-filter-wrap d-flex justify-content-between align-items-center">
                    <div className="product-filter-left d-flex">
                      <button className="shop-list-btn m-r10">
                        <i className="feather-grid" />
                      </button>
                      <button className="shop-list-btn m-r10">
                        <i className="feather-list" />
                      </button>
                      <form
                        className="woocommerce-ordering select-box-border-style1-wrapper"
                        method="get"
                      >
                        <select
                          className="form-select"
                          aria-label="Default select example"
                        >
                          <option value="menu_order">Default sorting</option>
                          <option value="popularity">Sort by popularity</option>
                          <option value="rating">Sort by average rating</option>
                          <option value="date">Sort by latest</option>
                          <option value="price">
                            Sort by price: low to high
                          </option>
                          <option value="price-desc">
                            Sort by price: high to low
                          </option>
                        </select>
                      </form>
                    </div>
                    <div className="product-filter-right d-flex align-items-center">
                      <span className="woocommerce-result-count">
                        <span>25, 316, 00</span> Products Available.
                      </span>
                      <div className="aon-pro-search aon-pro-search2">
                        <input
                          className="form-control sf-form-control"
                          name="company_name"
                          type="text"
                          placeholder="Search"
                        />
                        <button className="pro-search-btn">
                          <i className="fs-input-icon feather-search" />
                        </button>
                      </div>
                    </div>
                  </div> */}

                  {myData.map((data, index) => {
                    return (
                      <div className="aon-shop2-list d-flex m-b30">
                        <div className="aon-shop2-pic">
                          <img src={'/'+data?.image} alt="not" />
                        </div>
                        <div className="aon-shop2-info">
                          <h4 className="aon-shop2-title">{data?.title}  {
                            data?.premium ?  <img style={{width: '80px'}} src="/images/premium.png"/> : null
                           } </h4>
                          
                           {
                            data?.Function ?  <><p className="aon-shop2-text"> <b>Functions :</b> {data?.Function}</p> </> : null
                           }

                          {
                            data?.['Suitable For'] ?  <><p className="aon-shop2-text"> <b>Suitable For :</b> {data?.['Suitable For']}</p> </> : null
                           }
                           {
                            data?.['Efficacy'] ?  <><p className="aon-shop2-text"> <b>Efficiency :</b> {data?.['Efficacy']}</p> </> : null
                           }
                           {
                            data?.['Variety'] ?  <><p className="aon-shop2-text"> <b>Variety :</b> {data?.['Variety']}</p> </> : null
                           }
                         
                          <div className="aon-shop2-bot d-flex">
                            {/* <div className="aon-shop2-botLeft d-flex">
                            <div className="aon-shop2-price">$29.00</div>
                            <div className="aon-shop2-rating">
                              <div className="aon-df2-rating">
                                <span className="fa fa-star" />
                                <span className="fa fa-star" />
                                <span className="fa fa-star" />
                                <span className="fa fa-star text-gray" />
                                <span className="fa fa-star text-gray" />
                              </div>
                            </div>
                          </div>
                          <div className="aon-shop2-botRight d-flex">
                            <button className="aon-shop2-btn" type="button">
                              <i className="fa fa-heart" />
                            </button>
                            <button className="aon-shop2-btn" type="button">
                              <i className="fa fa-shopping-basket" /> Add To
                              Cart
                            </button>
                          </div> */}
                            <div className="text-center">
                              <a
                                onClick={() => productNavigate(data.id)}
                                className="file-btn site-button btn-animate-one btn-block"
                              >
                                <i className="flaticon-pdf" /> More Details
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {/* <div className="aon-shop2-list d-flex m-b30">
                    <div className="aon-shop2-pic">
                      <img src="images/products/pic-2.png" alt="" />
                    </div>
                    <div className="aon-shop2-info">
                      <h4 className="aon-shop2-title">Organic Food</h4>
                      <p className="aon-shop2-text">
                        Nunc cursus imperdiet orci, eget hendrerit ante gravida
                        ut. Aenean non mauris orci. Mauris a magna id erat
                        fermentum euismod non ut lorem. Morbi neque mi,
                        ultricies sit amet vulputate.
                      </p>
                      <div className="aon-shop2-bot d-flex">
                        <div className="aon-shop2-botLeft d-flex">
                          <div className="aon-shop2-price">$29.00</div>
                          <div className="aon-shop2-rating">
                            <div className="aon-df2-rating">
                              <span className="fa fa-star" />
                              <span className="fa fa-star" />
                              <span className="fa fa-star" />
                              <span className="fa fa-star text-gray" />
                              <span className="fa fa-star text-gray" />
                            </div>
                          </div>
                        </div>
                        <div className="aon-shop2-botRight d-flex">
                          <button className="aon-shop2-btn" type="button">
                            <i className="fa fa-heart" />
                          </button>
                          <button className="aon-shop2-btn" type="button">
                            <i className="fa fa-shopping-basket" /> Add To Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="aon-shop2-list d-flex m-b30">
                    <div className="aon-shop2-pic">
                      <img src="images/products/pic-3.png" alt="" />
                    </div>
                    <div className="aon-shop2-info">
                      <h4 className="aon-shop2-title">Organic Food</h4>
                      <p className="aon-shop2-text">
                        Nunc cursus imperdiet orci, eget hendrerit ante gravida
                        ut. Aenean non mauris orci. Mauris a magna id erat
                        fermentum euismod non ut lorem. Morbi neque mi,
                        ultricies sit amet vulputate.
                      </p>
                      <div className="aon-shop2-bot d-flex">
                        <div className="aon-shop2-botLeft d-flex">
                          <div className="aon-shop2-price">$29.00</div>
                          <div className="aon-shop2-rating">
                            <div className="aon-df2-rating">
                              <span className="fa fa-star" />
                              <span className="fa fa-star" />
                              <span className="fa fa-star" />
                              <span className="fa fa-star text-gray" />
                              <span className="fa fa-star text-gray" />
                            </div>
                          </div>
                        </div>
                        <div className="aon-shop2-botRight d-flex">
                          <button className="aon-shop2-btn" type="button">
                            <i className="fa fa-heart" />
                          </button>
                          <button className="aon-shop2-btn" type="button">
                            <i className="fa fa-shopping-basket" /> Add To Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="aon-shop2-list d-flex m-b30">
                    <div className="aon-shop2-pic">
                      <img src="images/products/pic-4.png" alt="" />
                    </div>
                    <div className="aon-shop2-info">
                      <h4 className="aon-shop2-title">Organic Food</h4>
                      <p className="aon-shop2-text">
                        Nunc cursus imperdiet orci, eget hendrerit ante gravida
                        ut. Aenean non mauris orci. Mauris a magna id erat
                        fermentum euismod non ut lorem. Morbi neque mi,
                        ultricies sit amet vulputate.
                      </p>
                      <div className="aon-shop2-bot d-flex">
                        <div className="aon-shop2-botLeft d-flex">
                          <div className="aon-shop2-price">$29.00</div>
                          <div className="aon-shop2-rating">
                            <div className="aon-df2-rating">
                              <span className="fa fa-star" />
                              <span className="fa fa-star" />
                              <span className="fa fa-star" />
                              <span className="fa fa-star text-gray" />
                              <span className="fa fa-star text-gray" />
                            </div>
                          </div>
                        </div>
                        <div className="aon-shop2-botRight d-flex">
                          <button className="aon-shop2-btn" type="button">
                            <i className="fa fa-heart" />
                          </button>
                          <button className="aon-shop2-btn" type="button">
                            <i className="fa fa-shopping-basket" /> Add To Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="aon-shop2-list d-flex m-b30">
                    <div className="aon-shop2-pic">
                      <img src="images/products/pic-1.png" alt="" />
                    </div>
                    <div className="aon-shop2-info">
                      <h4 className="aon-shop2-title">Organic Food</h4>
                      <p className="aon-shop2-text">
                        Nunc cursus imperdiet orci, eget hendrerit ante gravida
                        ut. Aenean non mauris orci. Mauris a magna id erat
                        fermentum euismod non ut lorem. Morbi neque mi,
                        ultricies sit amet vulputate.
                      </p>
                      <div className="aon-shop2-bot d-flex">
                        <div className="aon-shop2-botLeft d-flex">
                          <div className="aon-shop2-price">$29.00</div>
                          <div className="aon-shop2-rating">
                            <div className="aon-df2-rating">
                              <span className="fa fa-star" />
                              <span className="fa fa-star" />
                              <span className="fa fa-star" />
                              <span className="fa fa-star text-gray" />
                              <span className="fa fa-star text-gray" />
                            </div>
                          </div>
                        </div>
                        <div className="aon-shop2-botRight d-flex">
                          <button className="aon-shop2-btn" type="button">
                            <i className="fa fa-heart" />
                          </button>
                          <button className="aon-shop2-btn" type="button">
                            <i className="fa fa-shopping-basket" /> Add To Cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="aon-paging-control">
                    <div className="site-pagination2">
                      <ul className="pagination">
                        <li className="page-item">
                          <a className="page-link" href="#">
                            01
                          </a>
                        </li>
                        <li className="page-item active">
                          <a className="page-link" href="#">
                            02
                          </a>
                        </li>
                        <li className="page-item">
                          <a className="page-link" href="#">
                            03
                          </a>
                        </li>
                        <li className="page-item">
                          <a className="page-link" href="#">
                            04
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="aon-paging-arrow">
                      <div className="aon-paging-arrow-inner">
                        <button type="button">
                          <i className="flaticon-left-arrow" />
                        </button>
                        <button type="button">
                          <i className="flaticon-right-arrows" />
                        </button>
                      </div>
                    </div> */}
                  {/* </div> */}
                </div>
                {/* Left PartEND */}
                {/* Side bar start */}
                <div className="col-lg-3 col-md-12">
                  <aside className="side-bar2 ">
                    {/* SEARCH */}
                    {/* <div className="widget ">
                      <div className="widget_search_bx2">
                        <div className="text-left m-b30">
                          <h3 className="widget-title">Search Here</h3>
                        </div>
                        <form role="search" method="post">
                          <div className="input-group">
                            <input
                              name="news-letter"
                              type="text"
                              className="form-control"
                              placeholder="Enter your keyword..."
                            />
                            <span className="input-group-btn">
                              <button type="submit" className="btn">
                                <i className="fa fa-search" />
                              </button>
                            </span>
                          </div>
                        </form>
                      </div>
                    </div> */}
                    {/* CATEGORY */}
                    <div className="widget widget_services ">
                      <div className="text-left m-b30">
                        <h3 className="widget-title">Products</h3>
                      </div>
                      <ul>
                        <li className={productName == 'Cattle Feed Pellets' ? "active" : ""}>
                          <a href="/product/1">Cattle Feed Pellets</a>
                        </li>
                        <li className={productName == 'Maize Oil Cake' ? "active" : ""} >
                          <a href="/product/2">
                          Maize Oil Cake
                          </a>
                        </li>
                        <li className={productName == 'Cotton seed cake' ? "active" : ""}>
                          <a href="/product/3">Cotton seed cake</a>
                        </li>
                        <li className={productName == 'Organic Fertilizer' ? "active" : ""}>
                          <a href="/product/4">Organic Fertilizer</a>
                        </li>
                       
                      </ul>
                    </div>
                    {/* CATEGORY */}
                    <div className="widget widget_download-file ">
                      {/* <div className="text-left m-b30">
                        <h3 className="widget-title">Download Now</h3>
                      </div> */}
                      {/* <a
                        href="javascript:;"
                        className="file-btn site-button-secondry btn-animate-one btn-block"
                      >
                        <i className="flaticon-pdf" /> Download
                      </a> */}
                      <a
                        onClick={() => {
                          window.open("/cattle feed.pdf");
                        }}
                        className="file-btn site-button btn-animate-one btn-block"
                      >
                        <i className="fa fa-file-pdf" /> Brochure
                      </a>
                    </div>
                    <div className="aon-widget-help aon-w-h-2">
                      <div className="aon-widget-help-top">
                        <img src="images/need-help.jpg" alt="" />
                        <div className="aon-widget-help-mid">
                          <h3 className="help-title">We Need Help?</h3>
                          {/* <p>Lorem ipsum dolor sit amet.</p> */}
                          <br></br>
                        </div>
                      </div>
                      <div className="aon-widget-help-bottom">
                        <div className="aon-media">
                          <i className="fa fa-question" />
                        </div>
                        <div className="aon-helpbot-coontent">
                          <span>Contact Us 24/7</span>
                          <h3><a style={{color: 'white'}} href="tel:08045803774">+91 8045803774</a></h3>
                        </div>
                      </div>
                    </div>
                  </aside>
                </div>
                {/* Side bar END */}
              </div>
            </div>
          </div>
        </div>
        {/* Product Section  END */}
        {/* add Area */}
        <section className="aon-add-area">
          <div className="container">
            <div className="section-content">
              <img src="images/add-one.png" alt="" />
            </div>
          </div>
          <div className="site-bot-line" />
        </section>
        {/* add Area End */}
      </div>
    </>
  );
}

export default ProductList;
